import { getSVGImageUrl } from 'lib/image/imageUtils'
import React from 'react'
import { useIntl } from 'react-intl'

function useWhyWorkForUsItems() {
  const intl = useIntl()

  return [
    {
      title: intl.formatMessage({
        id: 'CxEkctVkkoQqpKw7hEps',
        defaultMessage: 'Discounted Luxury Escapes Travel',
        description: 'Benefit title for discounted travel perk on careers page',
      }),
      text: intl.formatMessage({
        id: 'Xx0VjGboKgsLthrp7Wb9',
        defaultMessage: 'Our team receive up to 20% off Luxury Escapes products.',
        description: 'Benefit description for discounted travel perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-bestpriceguarantee')}
        alt={intl.formatMessage({
          id: 'Qt9cCKG44VH5ubzIdrbe',
          defaultMessage: 'best price guarantee',
          description: 'Alt text for discounted travel benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'XZITB5mUu_gPSBuq2n78',
        defaultMessage: 'Birthday Leave',
        description: 'Benefit title for birthday leave perk on careers page',
      }),
      text: intl.formatMessage({
        id: 'ADmMlwjIX5gqoA6cIu4r',
        defaultMessage: 'Celebrate your special day by taking \u00BD a day off and receiving a $50 Luxury Escapes credit.',
        description: 'Benefit description for birthday leave perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-birthday')}
        alt={intl.formatMessage({
          id: 'OZS0y2N2TVnm0yXar4Ws',
          defaultMessage: 'birthday',
          description: 'Alt text for birthday leave benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'JWw6_gpW_o1pngUjFMrj',
        defaultMessage: 'Fitness',
        description: 'Benefit title for fitness perk on the careers page',
      }),
      text: intl.formatMessage({
        id: 'CkKgvqd11eTVGP8x_g-N',
        defaultMessage: 'Gyms on site or corporate gym memberships options available at discounted rates.',
        description: 'Benefit description for fitness perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-fitness')}
        alt={intl.formatMessage({
          id: '9ujr-a79jPsU2sknd245',
          defaultMessage: 'fitness',
          description: 'Accessibility alt text for fitness benefit icon on the careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'nOcsrwsAEK-dRlZskZfu',
        defaultMessage: 'Health & Wellbeing Program',
        description: 'Benefit title for health and wellbeing program on careers page',
      }),
      text: intl.formatMessage({
        id: 'K_ZhJYC980dtG-tLzDdQ',
        defaultMessage: 'Annual flu shots, lunch and learn sessions with health professionals, access to the LE employee assistance program.',
        description: 'Benefit description for health and wellbeing program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-wellbeing')}
        alt={intl.formatMessage({
          id: 'zAZlabZxBPgCzztfZt75',
          defaultMessage: 'wellbeing',
          description: 'Alt text for health and wellbeing benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'EMYy7wUZhZIKPWDA-VbJ',
        defaultMessage: 'Baby Bonus and Partner Leave',
        description: 'Benefit title for parental leave perk on careers page',
      }),
      text: intl.formatMessage({
        id: 'ZYJos1CnfjVmDMkYEz4k',
        defaultMessage: 'Having a Bub? Enjoy 8 weeks bonus pay as primary carer!',
        description: 'Benefit description for parental leave perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-dad_partner_pay')}
        alt={intl.formatMessage({
          id: '3o66VvKtL0qa7ER6kk1V',
          defaultMessage: 'dad partner pay',
          description: 'Alt text for parental leave benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'meXEgjUogfYwkxQI_Pc9',
        defaultMessage: 'Break to Donate',
        description: 'Benefit title for blood donation leave on careers page',
      }),
      text: intl.formatMessage({
        id: '1-JJqJT5RC456D4PfDyx',
        defaultMessage: 'Feel like donating blood? Take paid time off to do so!',
        description: 'Benefit description for blood donation leave on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-blood')}
        alt={intl.formatMessage({
          id: 'CSzPPN9VPyJrP8tSn4JB',
          defaultMessage: 'blood',
          description: 'Alt text for blood donation leave benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: '2T1L54yzOdB5iHoQjEZW',
        defaultMessage: 'Flexibility',
        description: 'Benefit title for flexible work environment on careers page',
      }),
      text: intl.formatMessage({
        id: 'oM3fR27fBGTOLeKTH_VY',
        defaultMessage: 'Fun, dynamic and flexible work environment.',
        description: 'Benefit description for flexible work environment on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-flexibility')}
        alt={intl.formatMessage({
          id: 'mBqyEBv5CmANvBuww-cL',
          defaultMessage: 'flexibility',
          description: 'Alt text for flexible work benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'FeDpwF0SDQipqMBlpome',
        defaultMessage: 'Regular Networking Events',
        description: 'Benefit title for networking events on careers page',
      }),
      text: intl.formatMessage({
        id: '-9B1oFvG4x0k3ZXqQeDK',
        defaultMessage: 'Celebration and recognition prizes, ping pong onsite, wine tastings and much more!',
        description: 'Benefit description for networking events on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-team_building')}
        alt={intl.formatMessage({
          id: 'So7v1nqFOsiF0QMZpBBe',
          defaultMessage: 'team building',
          description: 'Alt text for networking events benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'mnxf8A6rKEaZOfXiMxpM',
        defaultMessage: 'Learning & Development',
        description: 'Benefit title for learning and development on careers page',
      }),
      text: intl.formatMessage({
        id: '-6kDXrBvp96F_7Z0KS7H',
        defaultMessage: 'Build your career with Leadership Programs sponsored by our CEO, eLearning courses and onsite workshops.',
        description: 'Benefit description for learning and development on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-learning')}
        alt={intl.formatMessage({
          id: '2DdFfHnfyvikHNDMv9bW',
          defaultMessage: 'learning',
          description: 'Alt text for learning and development benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'li3BhAu05P2uLT9PT8zK',
        defaultMessage: 'Refer a Friend',
        description: 'Benefit title for employee referral program on careers page',
      }),
      text: intl.formatMessage({
        id: 'ygi3xstazG9ftl4Iw3ER',
        defaultMessage: 'Know someone who has what it takes to join the LE team? Enjoy a $2500 referral reward for successfully referring someone to LE!',
        description: 'Benefit description for employee referral program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-referral')}
        alt={intl.formatMessage({
          id: 'x51oVJV3jUOGK1ajqBVu',
          defaultMessage: 'referral',
          description: 'Alt text for employee referral benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'cO4GAzkjQ2n8YQfXD5na',
        defaultMessage: 'Breakfast and Lunches',
        description: 'Benefit title for free meals perk on the careers page',
      }),
      text: intl.formatMessage({
        id: '0J8LXXIDz9KsbhVANy26',
        defaultMessage: 'Breakfast and lunches supplied, along with fresh fruit and coffee.',
        description: 'Benefit description for free meals perk on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-breakfast')}
        alt={intl.formatMessage({
          id: 'nEgwx_Siz4bZFdUqzf4x',
          defaultMessage: 'breakfast',
          description: 'Alt text for free meals benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'cI4G5ll_SQ2Qwh1zDIpx',
        defaultMessage: 'Culture First',
        description: 'Benefit title for inclusive culture on careers page',
      }),
      text: intl.formatMessage({
        id: '1eGR4IxnrCRLGr6EnBji',
        defaultMessage: 'We look to add to our culture with every hire \u2013 you don’t need to conform to succeed here.',
        description: 'Benefit description for inclusive culture on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-culture')}
        alt={intl.formatMessage({
          id: 'leYyC29DIxz1xZSTbJaP',
          defaultMessage: 'culture',
          description: 'Alt text for inclusive culture benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'waz0smFCKqFOXM6q9PSx',
        defaultMessage: 'Seamless Communication',
        description: 'Benefit title for communication practices on careers page',
      }),
      text: intl.formatMessage({
        id: 'oB4zIFvBdwPoPl5iA_UE',
        defaultMessage: 'Stay in the loop with fortnightly newsletter updates and regular team meetings on both a global and local scale.',
        description: 'Benefit description for communication practices on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-communication')}
        alt={intl.formatMessage({
          id: 'PJlmmkO6fX4NakqJO58a',
          defaultMessage: 'communication',
          description: 'Alt text for seamless communication benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'jXrPYjdWdbGvwcoxJqQI',
        defaultMessage: 'Purchase Annual Leave Program',
        description: 'Benefit title for purchase leave program on careers page',
      }),
      text: intl.formatMessage({
        id: '-Yj04KoEkJ25DHuf0Cwb',
        defaultMessage: 'Fancy some extra time off each year? We offer a purchase leave program of up to an additional 4 weeks per year.',
        description: 'Benefit description for purchase leave program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_calendar')}
        alt={intl.formatMessage({
          id: 'M8Ljs1IDCaO2RS4Qeegc',
          defaultMessage: 'calendar',
          description: 'Alt text for purchase leave program benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'at6nVDuyaHvzl0chVli3',
        defaultMessage: 'Novated Lease Program',
        description: 'Benefit title for novated lease program on careers page',
      }),
      text: intl.formatMessage({
        id: '-Bk5LjoW7jRXF1kt6pDK',
        defaultMessage: 'Looking for a new set of wheels? Purchase a new or used car through our motor vehicle novated leasing program.',
        description: 'Benefit description for novated lease program on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_car')}
        alt={intl.formatMessage({
          id: 'bv4HE5L_qw_tlK9wiEzB',
          defaultMessage: 'car',
          description: 'Alt text for novated lease program benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: '1hOsjlYbzt_H36TNHJ9U',
        defaultMessage: 'Familiarisation Trips',
        description: 'Benefit title for familiarisation trips on careers page',
      }),
      text: intl.formatMessage({
        id: 'v7neL-MHyOOfjIoFP8Pl',
        defaultMessage: 'Immerse yourself in the same luxurious travel experiences that our customers enjoy.',
        description: 'Benefit description for familiarisation trips on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_map')}
        alt={intl.formatMessage({
          id: '3p0shgfYs1JsFGJtK3UU',
          defaultMessage: 'map',
          description: 'Alt text for familiarisation trips benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'no95XbDTRN-HGMcWM3Id',
        defaultMessage: 'Holiday and Experience Giveaways',
        description: 'Benefit title for holiday giveaways on careers page',
      }),
      text: intl.formatMessage({
        id: '7fek9cS-g7MDMXoBs04B',
        defaultMessage: 'Luxury Escapes is super generous with our team with regular giveaways of credit to our team members and holidays at our Xmas celebrations!',
        description: 'Benefit description for holiday giveaways on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_tickets')}
        alt={intl.formatMessage({
          id: 'LpdDox-z800dBEs-tp90',
          defaultMessage: 'tickets',
          description: 'Alt text for holiday giveaways benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: '2VYuF7tHsx0rChjP-ZtP',
        defaultMessage: 'Hallmark Day Celebrations',
        description: 'Benefit title for hallmark day celebrations on careers page',
      }),
      text: intl.formatMessage({
        id: 'xLTw3AFGZ_ZeeuopgHms',
        defaultMessage: 'At Luxury Escapes we like to celebrate the extraordinary and the ordinary, join in for international cuisine days, donut day and more.',
        description: 'Benefit description for hallmark day celebrations on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-illustration_celebrate')}
        alt={intl.formatMessage({
          id: 'D-awjTVzJFiihHPFL0ad',
          defaultMessage: 'celebrate',
          description: 'Alt text for hallmark day celebrations benefit icon on careers page',
        })}
        height="68"
      />,
    },
    {
      title: intl.formatMessage({
        id: 'GxO75Z7RqwtMV37MQ1sT',
        defaultMessage: 'Loyalty Reward',
        description: 'Benefit title for loyalty reward on the careers page',
      }),
      text: intl.formatMessage({
        id: 'XEYgCFa1UXvoqJy_QT2P',
        defaultMessage: 'On your yearly anniversary of service with Luxury Escapes, we will gift you either a credit or a discount code to use on a fabulous Luxury Escapes holiday!',
        description: 'Benefit description for loyalty reward on careers page',
      }),
      icon: <img
        src={getSVGImageUrl('careers-tiles-loyalty-reward')}
        alt={intl.formatMessage({
          id: 'TT93NPni6CEv9p9KsvhU',
          defaultMessage: 'wellbeing',
          description: 'Alt text for loyalty reward benefit icon on careers page',
        })}
        height="68"
      />,
    },
  ]
}

export default useWhyWorkForUsItems
